import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';
import SbResolve from './SbResolve';
import ImageHandler from './ImageHandler';

const translation = function (meta, openGraph, settings) {
  const page = [];
  let siteSettings = settings;
  if (!siteSettings) {
    const settingsData = useStaticQuery(graphql`
      {
        storyblokEntry(slug: { eq: "settings" }) {
          content
        }
      }
    `);
    siteSettings = JSON.parse(settingsData.storyblokEntry.content);
  }

  if (!siteSettings.domain) {
    // eslint-disable-next-line no-console
    console.error(
      'PageInfoTranslator: Please ensure the domain settings are correct in storyblok!',
    );
    return null;
  }

  const url = useLocation();

  page.domain = siteSettings.domain;

  page.url = new URL(url.pathname + url.hash, siteSettings.domain);

  page.pageTitle =
    (meta && meta.title !== '' && `${meta.title} | ${siteSettings.name}`) ||
    (openGraph &&
      openGraph.title &&
      openGraph.title !== '' &&
      `${openGraph.title} | ${siteSettings.name}`) ||
    siteSettings.name;

  page.siteName = siteSettings.name;

  page.title = siteSettings.name;
  if (openGraph && openGraph.title) {
    page.title = openGraph.title;
  }
  if (meta && meta.title !== '') {
    page.title = meta.title;
  }

  page.description = siteSettings.description;
  if (openGraph && openGraph.description) {
    page.description = SbResolve(openGraph.description).replace(/<[^>]+>/g, '');
    if (page.description.length > 276) {
      page.description = `${page.description.substring(0, 280)}...`;
    }
  }
  if (meta && meta.description !== '') {
    page.description = meta.description;
  }

  page.author =
    (openGraph && openGraph.author !== '' && openGraph.author) ||
    siteSettings.author;

  page.imageOg =
    (openGraph &&
      openGraph.image &&
      openGraph.image != '' &&
      openGraph.image.filename) ||
    siteSettings.image.filename;

  page.image = ImageHandler(page.imageOg, '960x540');
  page.imageSquare = ImageHandler(page.imageOg, '960x960');

  page.type = openGraph && openGraph.type;

  return page;
};

export { translation };
